// src/pages/OnayBekleyenlerimPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

const talepTuruEtiket = {
  izin: '📅 İzin Talebi',
  masraf: '💸 Masraf Talebi',
  vize: '✈️ Vize Talebi',
  zimmet: '🖥️ Zimmet Talebi',
};

const talepTuruRenk = {
  izin: '#4F46E5',
  masraf: '#059669',
  vize: '#D97706',
  zimmet: '#7C3AED',
};

export default function OnayBekleyenlerimPage() {
  const [bekleyenler, setBekleyenler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [secili, setSecili] = useState(null);
  const [not, setNot] = useState('');
  const [islem, setIslem] = useState(false);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const r = await axios.get('/api/onay/bekleyenlerim');
      setBekleyenler(r.data);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { getir(); }, [getir]);

  const karar = async (kayitId, kararDegeri) => {
    if (kararDegeri === 'reddedildi' && !not) { setHata('Reddetmek için not giriniz'); return; }
    setIslem(true); setHata('');
    try {
      await axios.post('/api/onay/karar', { kayit_id: kayitId, karar: kararDegeri, not: not || null });
      setBasari(kararDegeri === 'onaylandi' ? 'Onaylandı!' : kararDegeri === 'revize' ? 'Revize istendi.' : 'Reddedildi.');
      setSecili(null);
      setNot('');
      setTimeout(() => setBasari(''), 3000);
      await getir();
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
    finally { setIslem(false); }
  };

  const NotSatiri = ({ label, deger }) => {
    const [acik, setAcik] = React.useState(false);
    const uzun = deger && deger.length > 80;
    return (
      <div style={{ background: '#F9FAFB', borderRadius: '6px', padding: '8px 10px' }}>
        <div style={{ fontSize: '10px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', marginBottom: '2px' }}>{label}</div>
        <div style={{ fontSize: '13px', fontWeight: 600, color: '#111827' }}>
          {uzun && !acik ? (
            <>
              {deger.slice(0, 80)}...{' '}
              <button onClick={() => setAcik(true)} style={{ background: 'none', border: 'none', color: '#4F46E5', fontSize: '12px', cursor: 'pointer', padding: 0, fontWeight: 600 }}>Devamı</button>
            </>
          ) : (
            <>
              {deger || '-'}
              {uzun && acik && (
                <button onClick={() => setAcik(false)} style={{ background: 'none', border: 'none', color: '#9CA3AF', fontSize: '12px', cursor: 'pointer', padding: '0 4px', fontWeight: 600 }}>↑</button>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  const talepDetayRender = (item) => {
    const t = item.talep || {};
    if (item.talep_turu === 'izin') return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '8px', marginTop: '10px' }}>
        {[
          { label: 'İzin Türü', deger: t.izin_turu },
          { label: 'Başlangıç', deger: fmt(t.baslangic_tarihi) },
          { label: 'Bitiş', deger: fmt(t.bitis_tarihi) },
          { label: 'Gün Sayısı', deger: String(t.gun_sayisi || '-') },
          { label: 'Açıklama', deger: t.aciklama || '-' },
        ].map(f => (
          <NotSatiri key={f.label} label={f.label} deger={f.deger} />
        ))}
      </div>
    );

    if (item.talep_turu === 'masraf') return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '8px', marginTop: '10px' }}>
        {[
          { label: 'Başlık', deger: t.baslik },
          { label: 'Toplam', deger: t.toplam_tutar ? Number(t.toplam_tutar).toLocaleString('tr-TR') + ' ' + (t.para_birimi || 'TRY') : '-' },
          { label: 'Tarih', deger: fmt(t.olusturma_tarihi) },
          { label: 'Açıklama', deger: t.aciklama || '-' },
        ].map(f => <NotSatiri key={f.label} label={f.label} deger={f.deger} />)}
      </div>
    );

    if (item.talep_turu === 'vize') return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '8px', marginTop: '10px' }}>
        {[
          { label: 'Gidilecek Ülke', deger: t.gidilecek_ulke },
          { label: 'İzin Başlangıç', deger: fmt(t.izin_baslangic) },
          { label: 'İzin Bitiş', deger: fmt(t.izin_bitis) },
          { label: 'Pozisyon', deger: t.pozisyon },
        ].map(f => <NotSatiri key={f.label} label={f.label} deger={f.deger} />)}
      </div>
    );

    return null;
  };

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>✅ Onay Bekleyenlerim</h1>
        <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>
          {bekleyenler.length} bekleyen talep
        </p>
      </div>

      {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>⚠️ {hata}</div>}
      {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>✅ {basari}</div>}

      {yukleniyor ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9CA3AF' }}>Yükleniyor...</div>
      ) : bekleyenler.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '80px', background: '#F9FAFB', borderRadius: '16px', border: '2px dashed #E5E7EB' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>🎉</div>
          <h3 style={{ color: '#374151', fontWeight: 700, fontSize: '18px', marginBottom: '8px' }}>Tüm onaylar tamamlandı!</h3>
          <p style={{ color: '#6B7280', fontSize: '14px' }}>Bekleyen onay talebiniz yok.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {bekleyenler.map(item => {
            const renk = talepTuruRenk[item.talep_turu] || '#4F46E5';
            const acik = secili === item.id;
            return (
              <div key={item.id} style={{
                background: '#fff', borderRadius: '12px',
                border: `1.5px solid ${acik ? renk : '#E5E7EB'}`,
                boxShadow: acik ? `0 4px 16px ${renk}20` : '0 1px 4px rgba(0,0,0,0.06)',
                overflow: 'hidden', transition: 'all 0.2s'
              }}>
                {/* Başlık */}
                <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <div style={{
                    width: '44px', height: '44px', borderRadius: '10px',
                    background: renk + '15', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '20px', flexShrink: 0
                  }}>
                    {talepTuruEtiket[item.talep_turu]?.split(' ')[0]}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 700, fontSize: '15px', color: '#111827' }}>
                        {item.talep?.personel_ad || 'Personel'}
                      </span>
                      <span style={{ background: renk + '15', color: renk, fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 700 }}>
                        {talepTuruEtiket[item.talep_turu] || item.talep_turu}
                      </span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '3px' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{item.adim_baslik}</span>
                      {' · '}Talep #{item.talep_id}
                      {' · '}{fmt(item.olusturma_tarihi)}
                    </div>
                  </div>

                  <button
                    onClick={() => { setSecili(acik ? null : item.id); setNot(''); setHata(''); }}
                    style={{
                      background: acik ? renk : '#F3F4F6',
                      color: acik ? '#fff' : '#374151',
                      border: 'none', padding: '8px 18px', borderRadius: '8px',
                      cursor: 'pointer', fontWeight: 600, fontSize: '13px',
                      transition: 'all 0.15s', flexShrink: 0
                    }}
                  >
                    {acik ? 'Kapat' : 'İncele'}
                  </button>
                </div>

                {/* Detay paneli */}
                {acik && (
                  <div style={{ borderTop: '1px solid #F3F4F6', padding: '16px 20px', background: '#FAFAFA' }}>
                    {talepDetayRender(item)}

                    <div style={{ marginTop: '16px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                        <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Not (isteğe bağlı)</label>
                        <span style={{ fontSize: '11px', color: not.length > 200 ? '#DC2626' : '#9CA3AF' }}>{not.length}/500</span>
                      </div>
                      <textarea
                        value={not}
                        onChange={e => setNot(e.target.value.slice(0, 500))}
                        placeholder="Onay veya red gerekçesini yazın..."
                        rows={3}
                        style={{ width: '100%', padding: '10px 12px', border: `1.5px solid ${not.length > 200 ? '#FCA5A5' : '#E5E7EB'}`, borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', background: '#fff', resize: 'vertical', lineHeight: '1.5' }}
                      />
                    </div>

                    <div style={{ display: 'flex', gap: '10px', marginTop: '14px' }}>
                      <button
                        onClick={() => karar(item.id, 'onaylandi')}
                        disabled={islem}
                        style={{ flex: 2, padding: '11px', background: '#059669', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 700, fontSize: '14px', opacity: islem ? 0.6 : 1 }}
                      >
                        ✓ Onayla
                      </button>
                      <button
                        onClick={() => karar(item.id, 'revize')}
                        disabled={islem}
                        style={{ flex: 1, padding: '11px', background: '#FEF3C7', color: '#92400E', border: '1.5px solid #F59E0B', borderRadius: '8px', cursor: 'pointer', fontWeight: 700, fontSize: '14px', opacity: islem ? 0.6 : 1 }}
                      >
                        ↩ Revize
                      </button>
                      <button
                        onClick={() => karar(item.id, 'reddedildi')}
                        disabled={islem}
                        style={{ flex: 1, padding: '11px', background: '#FEF2F2', color: '#DC2626', border: '1.5px solid #FCA5A5', borderRadius: '8px', cursor: 'pointer', fontWeight: 700, fontSize: '14px', opacity: islem ? 0.6 : 1 }}
                      >
                        ✗ Reddet
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
